import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { DealModel } from 'src/app/models/deal.model';
import { DealsService } from 'src/app/services/deals.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { DealPipelineWorkflowService } from 'src/app/services/settings-services/deal-pipeline-workflow.service';
import DateUtils from 'src/app/utils/date';

@Component({
  selector: 'app-deal-stage-conversation',
  templateUrl: './deal-stage-conversation.component.html',
  styleUrls: ['./deal-stage-conversation.component.css']
})
export class DealStageConversationComponent implements OnInit {
  dateUtil = new DateUtils;
  dateRange = { startDate: null, endDate: null }
  showChart = false;
  workflows$;
  dealsData;
  selectedWorkflow = '';
  selectedIds = null; selectedType = null;
  stages;
  public chartOptions = {
    series: [
      {
        name: "deal won",
        data: []
      },
      {
        name: "deal lost",
        data: []
      },
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: true,
        // distributed: true,
        // columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    yaxis: {
      title: {
        text: `stages`,
      },
    },
    xaxis: {
      categories: ['Stage 1', 'Stage 2', 'Stage 3', 'Stage 4', 'Stage 5'],
      title: {
        text: 'count',
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return this.baseCurrency + val;
        }
      }
    },
    colors: [
      "rgb(144,238,144)", "rgb(255,0,0)",
    ]
  };
  defaultData = {
    2: {}, 1: {}
  }
  dateType = '90';
  constructor(
    private dealSrv: DealsService,
    private performRepSrv: PerformanceReportService,
    private dealWorkflow: DealPipelineWorkflowService
  ) {
    this.dateRange = this.dateUtil.getDefReportDateRange(Number(this.dateType));
    this.workflows$ = this.dealWorkflow.getDealsPipelineWorkflow();
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
      }
    })
  }

  ngOnInit() {
    // this.getDeals()
  }
  dateChange({ dateRange, dateType }) {
    this.dateRange = dateRange;
    this.dateType = dateType;
    this.getDeals();
  }
  getStages() {
    this.stages = {};
    const stageIds = [];
    this.dealWorkflow.getDealsPipelineStageByDealId(this.selectedWorkflow)
      .subscribe((data: any[]) => {
        data.forEach(dat => {
          this.stages[dat.id] = dat
          stageIds.push(dat.id);
        })
        this.getStageToClosure(stageIds);
      });
  }
  getStageToClosure(stageIds: any[]) {
    const dateFilter = null;
    const wonStages = this.dealSrv.fetchStagesToClosure(stageIds, { dateFilter, status: 2 }).pipe(map((deals: any[]) => {
      return deals.map(deal => ({ ...deal, name: this.stages[deal.id].name }))
    }));
    forkJoin([wonStages]).subscribe(([wonSt]) => {
    })
  }
  getDeals() {
    this.showChart = false;
    let filter: any = { dateFilter: this.dateRange }
    if (this.selectedType === 'salesperson') {
      filter = { ...filter, salesPerson: { ids: this.selectedIds } }
    }
    this.dealSrv.fetchDeals(this.selectedIds, filter).pipe(map((deals: DealModel[]) => {

      return deals.filter(deal => (deal.salesProcessID === this.selectedWorkflow && deal.status > 0)).map(deal => {
        const lastStageNameBeforeClose = deal.lastStageNameBeforeClose ? deal.lastStageNameBeforeClose : 'Others'
        return { ...deal, lastStageNameBeforeClose }
      })
    }))
      .subscribe((res: any) => {
        this.dealsData = res;
        this.manipulateData(res)
      })
  }
  manipulateData(deals: DealModel[]) {
    const allStages = [];
    deals.forEach(deal => {
      if (allStages.indexOf(deal.lastStageNameBeforeClose) === -1) {
        allStages.push(deal.lastStageNameBeforeClose);
      }
    })
    const wonStages = [...new Array(allStages.length).fill(0)];
    const lossStages = [...new Array(allStages.length).fill(0)];
    deals.forEach(deal => {
      if (deal.status === 2) {
        const stageIndex = allStages.indexOf(deal.lastStageNameBeforeClose);
        let stageCount = wonStages[stageIndex];
        wonStages[stageIndex] = stageCount + 1;
      }
      if (deal.status === 1) {
        const stageIndex = allStages.indexOf(deal.lastStageNameBeforeClose);
        let stageCount = lossStages[stageIndex];
        lossStages[stageIndex] = stageCount + 1;
      }
    })
    this.chartOptions.xaxis.categories = allStages
    this.chartOptions.series[0].data = wonStages;
    this.chartOptions.series[1].data = lossStages;
    this.showChart = true
  }


}
